<template>
  <gd-modal ref="upgradeModal" name="upgrade" :title="$t('frontend_groovevideo_videos_index_upgrade_to_pro_today')">
    <div class="flex flex-col items-center justify-center p-8">
      <p class="text-lg leading-loose mb-8 text-grey-800 text-center" v-html="$t('frontend_upgrade_message')"></p>
      <div class="flex flex-col items-center justify-center">
        <a
         @click="goToUpgradePage"
          class="flex items-center px-6 py-3 heading-sm focus:outline-none shadow hover:shadow-lg focus:shadow-lg rounded-lg bg-green-extra-dark text-white border-green-extra-dark border border-solid text-lg"
          >{{ $t('frontend_grooveblog_upgrade_modal_see_all') }}</a
        >
        <button class="mb-10 mt-6" @click="$refs.upgradeModal.close()">
          {{ $t('frontend_grooveblog_upgrade_modal_no_thanks') }}
        </button>
      </div>
    </div>
  </gd-modal>
</template>
<script>
import GdModal from '@groovepages/gd-ui-kit/components/Modal';
import GdButton from '@groovepages/gd-ui-kit/components/Button';
import auth from '@groovepages/gd-lib/auth';

export default {
  components: {
    GdModal,
    GdButton,
  },
  methods: {
    open() {
      this.$refs.upgradeModal.open();
    },
    goToUpgradePage() {
      let user = auth.authenticatedUser();
      let url = window.gdEnv[`UPGRADE_URL_${user?.metadata?.region?.toUpperCase()}`] || window.gdEnv[`UPGRADE_URL`];
      window.open(url, '_blank');
    },
  },
};
</script>
